import {mobileVhFix} from './utils/mobile-vh-fix';
import {initAccordion} from './modules/accordion/init-accordion';
// import {initCustomSelect} from './modules/custom-select/init-custom-select';
import {initHeader} from './modules/header/init-header';
import {initModals} from './modules/modal/init-modals';
import {initPhoneMask} from './modules/init-phone-mask';
import {initTabs} from './modules/tabs/init-tabs';
import {cookieBannerHandler} from './modules/cookie-banner-handler';
import {initValidation} from './modules/bitrix/validation/init-validation';
import {initIntroSlider} from './modules/slider/init-intro-slider';
import {initNoveltiesInfiniteSlider} from './modules/slider/init-novelties-infinite-slider';
import {initNoveltiesTabsSlider} from './modules/slider/init-novelties-tabs-slider';
import {initMoreless} from './modules/moreless/init-moreless';
import {rotateResetBtn} from './modules/init-rotate-reset-btn';
import {initQuantity} from './modules/init-quantity';
import {initCopyText} from './modules/init-copy-text';
import {initCatalogOverview} from './modules/init-catalog-overview';
import {initCertificates} from './modules/init-certificates';


window.addEventListener('DOMContentLoaded', () => {
  // Utils
  // ---------------------------------

  mobileVhFix();

  // Modules
  // ---------------------------------

  // initCustomSelect();
  initHeader();
  initCatalogOverview();
  initModals();
  initAccordion();
  initTabs();
  initPhoneMask();
  initIntroSlider();
  initNoveltiesInfiniteSlider();
  initNoveltiesTabsSlider();
  initValidation();
  cookieBannerHandler();
  initMoreless();
  rotateResetBtn();
  initQuantity();
  initCopyText();
  initCertificates();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
